import { Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { FunctionComponent } from 'react';
import { reduceResolution, wbp } from 'Theme';
import { useCommonStyles } from './CommonStyles';
import HeaderCell from './HeaderCell';

interface TableHeaderProps {
    className?: string;
}

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        spinner: {
            [theme.breakpoints.down(wbp)]: {
                marginTop: `${reduceResolution(50)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                marginTop: '50px'
            }
        },
        header: {
            marginTop: '12px',
            backgroundColor: '#FFF',
            borderBottom: '2px solid black',
            //justifyContent: 'space-between',
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            },
            [theme.breakpoints.up('md')]: {
                paddingTop: '18px',
                paddingBottom: '18px'
            }
        }
    })
);

export const TableHeader: FunctionComponent<TableHeaderProps> = props => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();

    return (
        <Grid
            container
            className={clsx(classes.header, commonClasses.rowContainer, props.className)}
        >
            <HeaderCell
                xl={3}
                lg={4}
                xs={3}
                title="Name"
                className={clsx(commonClasses.desktop)}
            />

            <HeaderCell
                xs={1}
                lg={2}
                title="Type"
                className={clsx(commonClasses.cellLeft, commonClasses.typeCell)}
            />

            <HeaderCell
                xs={1}
                title="Billing"
                className={clsx(commonClasses.cellLeft, commonClasses.smallWidthCell)}
            />

            <HeaderCell
                xs={1}
                title="Subscribed"
                className={clsx(commonClasses.cellRight, commonClasses.smallWidthCell)}
            />

            <HeaderCell
                xs={1}
                xl={1}
                title="Canceled"
                className={clsx(commonClasses.cellRight, commonClasses.smallWidthCell)}
            />

            <HeaderCell
                xs={1}
                title="Paused"
                className={clsx(commonClasses.cellRight, commonClasses.smallWidthCell)}
            />

            <HeaderCell
                xs={1}
                title="Price"
                className={clsx(commonClasses.cellRight, commonClasses.smallWidthCell)}
            />

            <HeaderCell
                xs={1}
                title=""
            />
        </Grid>
    );
};

export default TableHeader;
